import { FONT } from "../../../value/staticValues";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { ReactComponent as CpuImg } from "../../../img/ico-vpc-list-cpu.svg";
import { ReactComponent as MemoryImg } from "../../../img/ico-vpc-list-memory.svg";
import { ReactComponent as StorageImg } from "../../../img/ico-vpc-list-storage.svg";
import { ReactComponent as AlertImg } from "../../../img/ico-status-alert.svg";
import { ReactComponent as ErrorImg } from "../../../img/ico-status-error.svg";

import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import i18n from "../../../lang/base";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import CustomProgressBar from "../../base/CustomProgressBar";

export interface NodeData {
    node_id: string,
    node_name: string,
    up_yn: boolean,
    master_yn: boolean,
    ip_address: string,
    cpu_total_count: number,
    memory_total_capacity_mb: number,
    storage_total_capacity_gb: number,
    cpu_used_nano_cores: number,
    memory_used_capacity_mb: number,
    storage_used_capacity_gb: number,
    create_ts: string,
    update_ts: string,
    vm: {
      vm_id: string,
      vm_name: string
    },
    container_cluster: {
      container_cluster_id: string,
      container_cluster_name: string
    },
    project: {
      project_id: string,
      project_name: string
    }
  }

  export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "NODE_SYNC",
        }
    }
  ]

export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("NODE_NAME_TEXT"),
        accessor: "node_name",
        disableSortBy: false,
        style: {
            width: "150px",
            paddingLeft: "20px"
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, paddingLeft: 0}}>{value}</div>)
    },
    {
        Header: i18n.t("NODE_MASTER_TEXT"),
        accessor: "master_yn",
        disableSortBy: false,
        style: {
            width: "60px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.blueText, paddingLeft: 10}}>{value ? 'Y': 'N'}</div>)
    },
    {
        Header: i18n.t("NODE_STATUS_TEXT"),
        accessor: "up_yn",
        disableSortBy: true,
        style: {
            width: "60px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
                }
                {
                    value ? "Up" : "Down"
                }
            </div>
        )
    },
    {
        Header: i18n.t("IP_ADDRESS_TEXT"),
        accessor: "ip_address",
        disableSortBy: false,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.purpleText}}>{value}</div>)
    },
    {
        Header: i18n.t("CPU"),
        accessor: "cpu",
        disableSortBy: true,
        style: {
            width: "80px",
            paddingLeft: 20,
        },
        Cell: ({ cell: {value} }) => (
            value.percent < 80 ?
            <div style={className.usageContainer}>
                <div style={className.usageRowContainer}>
                    <CpuImg style={className.resourceImg}/>
                    <div style={className.usageText}>{value.total_count}cores</div>
                    <div style={className.usageCpuValue}>{value.percent}%</div>
                </div>
                <div style={className.usageRowContainer}>
                    <CustomProgressBar key={901} width={120} height={10} colors={["#4aaaff", "#f0f3fa"]} percent={value.percent}/>
                </div>
            </div>
            : value.percent >= 80 && value.percent < 90 ?
            <div style={{...className.usageContainer, paddingLeft: 0}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <AlertImg style={className.warnImg} />
                    <div>
                        <div style={className.usageRowContainer}>
                            <CpuImg style={className.resourceImg}/>
                            <div style={className.usageText}>{value.total_count}cores</div>
                            <div style={className.usageWarnValue}>{value.percent}%</div>
                        </div>
                        <div style={className.usageRowContainer}>
                            <CustomProgressBar key={901} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.percent}/>
                        </div>
                    </div>
                </div>
            </div>
            :
            <div style={{...className.usageContainer, paddingLeft: 0}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <ErrorImg style={className.warnImg} />
                    <div>
                        <div style={className.usageRowContainer}>
                            <CpuImg style={className.resourceImg}/>
                            <div style={className.usageText}>{value.total_count}cores</div>
                            <div style={className.usageWarnValue}>{value.percent}%</div>
                        </div>
                        <div style={className.usageRowContainer}>
                            <CustomProgressBar key={901} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.percent}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    },
    {
        Header: i18n.t("Memory"),
        accessor: "memory",
        disableSortBy: true,
        style: {
            width: "100px",
            paddingLeft: 20,
        },
        Cell: ({ cell: {value} }) => (
            value.percent < 80 ?
            <div style={className.usageContainer}>
                <div style={className.usageRowContainer}>
                    <MemoryImg style={className.resourceImg}/>
                    <div style={className.usageText}>{(value.total_count / 1024).toFixed(1)}GB</div>
                    <div style={className.usageMemoryValue}>{value.percent}%</div>
                </div>
                <div style={className.usageRowContainer}>
                    <CustomProgressBar key={902} width={120} height={10} colors={["#7560bd", "#f0f3fa"]} percent={value.percent}/>
                </div>
            </div>
            : value.percent >= 80 && value.percent < 95 ?
            <div style={{...className.usageContainer, paddingLeft: 0}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <AlertImg style={className.warnImg} />
                    <div>
                        <div style={className.usageRowContainer}>
                            <MemoryImg style={className.resourceImg}/>
                            <div style={className.usageText}>{(value.total_count / 1024).toFixed(1)}GB</div>
                            <div style={className.usageWarnValue}>{value.percent}%</div>
                        </div>
                        <div style={className.usageRowContainer}>
                            <CustomProgressBar key={902} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.percent}/>
                        </div>
                    </div>
                </div>
            </div>
            :
            <div style={{...className.usageContainer, paddingLeft: 0}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <ErrorImg style={className.warnImg} />
                    <div>
                        <div style={className.usageRowContainer}>
                            <MemoryImg style={className.resourceImg}/>
                            <div style={className.usageText}>{(value.total_count / 1024).toFixed(1)}GB</div>
                            <div style={className.usageWarnValue}>{value.percent}%</div>
                        </div>
                        <div style={className.usageRowContainer}>
                            <CustomProgressBar key={902} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.percent}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    },
    {
        Header: i18n.t("Storage"),
        accessor: "storage",
        disableSortBy: true,
        style: {
            width: "100px",
            // paddingLeft: 20,
        },
        Cell: ({ cell: {value} }) => (
            // value.percent < 80 ?
            // <div style={className.usageContainer}>
            //     <div style={className.usageRowContainer}>
            //         <MemoryImg style={className.resourceImg}/>
            //         <div style={className.usageText}>{(value.total_count / 1024).toFixed(1)}GB</div>
            //         <div style={className.usageStorageValue}>{value.percent}%</div>
            //     </div>
            //     <div style={className.usageRowContainer}>
            //         <CustomProgressBar key={902} width={120} height={10} colors={["#5a7ee9", "#f0f3fa"]} percent={value.percent}/>
            //     </div>
            // </div>
            // : value.percent >= 80 && value.percent < 95 ?
            // <div style={{...className.usageContainer, paddingLeft: 0}}>
            //     <div style={{display: "flex", alignItems: "center"}}>
            //         <AlertImg style={className.warnImg} />
            //         <div>
            //             <div style={className.usageRowContainer}>
            //                 <MemoryImg style={className.resourceImg}/>
            //                 <div style={className.usageText}>{(value.total_count / 1024).toFixed(1)}GB</div>
            //                 <div style={className.usageWarnValue}>{value.percent}%</div>
            //             </div>
            //             <div style={className.usageRowContainer}>
            //                 <CustomProgressBar key={902} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.percent}/>
            //             </div>
            //         </div>
            //     </div>
            // </div>
            // :
            // <div style={{...className.usageContainer, paddingLeft: 0}}>
            //     <div style={{display: "flex", alignItems: "center"}}>
            //         <ErrorImg style={className.warnImg} />
            //         <div>
            //             <div style={className.usageRowContainer}>
            //                 <MemoryImg style={className.resourceImg}/>
            //                 <div style={className.usageText}>{(value.total_count / 1024).toFixed(1)}GB</div>
            //                 <div style={className.usageWarnValue}>{value.percent}%</div>
            //             </div>
            //             <div style={className.usageRowContainer}>
            //                 <CustomProgressBar key={902} width={120} height={10} colors={["#e6735c", "#f0f3fa"]} percent={value.percent}/>
            //             </div>
            //         </div>
            //     </div>
            // </div>
            <div style={{...className.normalTextContainer}}>{value.total_count}GB</div>
        )
    },
    {
        Header: i18n.t("CONTAINER_CLUSTER_NAME_TEXT"),
        accessor: "container_cluster",
        disableSortBy: true,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.blueText}}>{ value?.container_cluster_name ? value.container_cluster_name : "-" }</div>)
    },
    {
        Header: i18n.t("VM_NAME_TEXT"),
        accessor: "vm",
        disableSortBy: true,
        style: {
            width: "140px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value?.vm_name ? value.vm_name : "-"}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: true,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: true,
        style: {
            width: "130px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    }
];


const className = {
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    statusImg: {
        marginRight: 3
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    resourceContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },

    blueContainer: {
        color: "#0853fb"
    },
    purpleText: {
        color: "#7066f1"
    },
    blueText: {
        color: "#0853fb"
    },
    greenText: {
        color: "#3a8344"
    },
    resourceImg: {
        width: 24,
        height: 24
    },
    usageContainer: {
        paddingLeft: 20
    },
    usageRowContainer: {
        width: "120px",
        display: "flex",
        alignItems: "center"
    },
    usageImg: {
        width: "24px",
        height: "24px",
        filter: "opacity(0.5)"
    },
    usageText: {
        fontFamily: FONT.REGULAR,
        fontSize: "10px",
        color: "#8793a3"
    },
    usageCpuValue: {
        marginLeft: "auto",
        marginRight: "5px",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        color: "#4aaad4"
    },
    usageMemoryValue: {
        marginLeft: "auto",
        marginRight: "5px",
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        color: "#7560bd"
    },
    usageStorageValue: {
        marginLeft: "auto",
        marginRight: "5px",
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        color: "#5a7ee9"
    },
    usageWarnValue: {
        marginLeft: "auto",
        marginRight: "5px",
        fontFamily: FONT.MEDIUM,
        fontSize: "12px",
        color: "#e6735c"
    },
    warnImg: {
        width: 20,
        height: 20
    }
}